import {
  getValidSecondaryEnv,
  isNamedEnv,
  NAMED_ENVS,
  type NamedEnv,
} from '@mathflat/shared/@common/devToolbar'
import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import type { LocalStorageDataT } from 'src/constant'

import { envUtils } from '../envUtils'
import { aiAxios } from './aiAxios'
import homepageAxios from './homepageAxios'
import maxios from './maxios'
import noxios from './noxios'
import podAxios from './podAxios'
import { remoteStorageAxios } from './remoteStorageAxios'
import { saiAxios } from './saiAxios'

export type { NamedEnv }
export { getValidSecondaryEnv, isNamedEnv, NAMED_ENVS }

const ENV_SUFFIX: Record<NamedEnv, string> = {
  dev: '-dev',
  stg: '-staging',
  live: '',
}

const setSecondaryAxios = (env: NamedEnv) => {
  const d = domainProvider.TARGET_DOMAIN
  const s = ENV_SUFFIX[env]
  noxios.defaults.baseURL = `https://messaging-api${s}.${d}`
  podAxios.defaults.baseURL = `https://pod-api${s}.${d}`
  homepageAxios.defaults.baseURL = `https://homepage-api${s}.${d}`
  remoteStorageAxios.defaults.baseURL = `https://remote-storage${s}.${d}`
  saiAxios.defaults.baseURL = `https://sai${s}.${d}`
  aiAxios.defaults.baseURL = `https://ai${s}.${d}`
  envUtils.studentAppURL = envUtils.getStudentAppURL(env)
}

// TODO: localStorageService 호출 시점이 너무 늦어서 localStorage로 대체
export const initAxiosDefaultBaseURL = (type: LocalStorageDataT['DEV_API'] | string) => {
  localStorage.setItem('DEV_API', type)

  if (isNamedEnv(type)) {
    maxios.defaults.baseURL = `https://api${ENV_SUFFIX[type]}.${domainProvider.TARGET_DOMAIN}`
    setSecondaryAxios(type)
    return
  }

  // custom URL: maxios만 커스텀, 보조 서버는 DEV_API_SECONDARY_ENV 기준
  maxios.defaults.baseURL = type
  setSecondaryAxios(getValidSecondaryEnv(localStorage.getItem('DEV_API_SECONDARY_ENV')))
}
